<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="500px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      ref="representativeReplacementForm"
      v-loading="loading"
      :model="representativeReplacement"
      :rules="rules"
      label-position="top"
      autocomplete="off"
      style="margin-bottom: 30px;"
      @submit.native.prevent="store"
    >
      <el-form-item
        prop="source_user_id"
        label="Forrás képviselő"
      >
        <el-select
          v-model="representativeReplacement.source_user_id"
          :disabled="type === 'update'"
          style="width: 100%;"
          filterable
        >
          <el-option
            v-for="user in users"
            :key="user.id"
            :label="`${user.last_name} ${user.first_name} (@${user.username})`"
            :value="user.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        prop="source_storage_id"
        label="Forrás raktár"
      >
        <el-select
          v-model="representativeReplacement.source_storage_id"
          :disabled="type === 'update'"
          style="width: 100%;"
          filterable
          default-first-option
        >
          <el-option
            v-for="storage in storages"
            v-if="storage.user_id === representativeReplacement.source_user_id"
            :key="storage.id"
            :label="storage.name"
            :value="storage.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        prop="target_user_id"
        label="Cél képviselő"
      >
        <el-select
          v-model="representativeReplacement.target_user_id"
          :disabled="type === 'update'"
          style="width: 100%;"
          filterable
        >
          <el-option
            v-for="user in users"
            :key="user.id"
            :label="`${user.last_name} ${user.first_name} (@${user.username})`"
            :value="user.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        prop="target_storage_id"
        label="Cél raktár"
      >
        <el-select
          v-model="representativeReplacement.target_storage_id"
          :disabled="type === 'update'"
          style="width: 100%;"
          filterable
          default-first-option
        >
          <el-option
            v-for="storage in storages"
            v-if="storage.user_id === representativeReplacement.target_user_id"
            :key="storage.id"
            :label="storage.name"
            :value="storage.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        prop="type"
        label="Áthelyezés típusa"
      >
        <el-select
          v-model="representativeReplacement.type"
          :disabled="type === 'update'"
          style="width: 100%;"
          filterable
        >
          <el-option
            label="Végleges áthelyezeés"
            value="move"
          />
          <el-option
            label="Helyettesítés"
            value="substitution"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="representativeReplacement.type === 'substitution'"
        label="Helyettesítés kezdete"
        prop="from"
      >
        <el-date-picker
          v-model="representativeReplacement.from"
          :disabled="type === 'update'"
          type="date"
          style="width: 100%;"
          :clearable="false"
          format="yyyy. MM. dd."
          value-format="yyyy-MM-dd"
          :picker-options="{ firstDayOfWeek: 1 }"
        />
      </el-form-item>
      <el-form-item
        v-if="representativeReplacement.type === 'substitution'"
        label="Helyettesítés vége"
        prop="to"
      >
        <el-date-picker
          v-model="representativeReplacement.to"
          :disabled="type === 'update'"
          type="date"
          style="width: 100%;"
          :clearable="false"
          format="yyyy. MM. dd."
          value-format="yyyy-MM-dd"
          :picker-options="{ firstDayOfWeek: 1 }"
        />
      </el-form-item>
      <el-form-item
        label="Megjegyzés"
        prop="comment"
      >
        <el-input
          v-model="representativeReplacement.comment"
          :disabled="type === 'update'"
          type="textarea"
        />
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <div>
        <el-button @click="handleClose">
          Mégse
        </el-button>
        <el-button
          type="primary"
          :disabled="type === 'update'"
          :loading="buttonLoading"
          @click="store"
        >
          {{ buttonText }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['type', 'representativeReplacementId'],
  data() {
    return {
      loading: false,
      buttonLoading: false,
      taskCount: 1,
      debit: null,
      userLoading: false,
      shops: [],
      shopLoading: false,
      representativeReplacement: {
        type: 'move',
      },
      rules: {
        source_user_id: [
          {
            required: true,
            message: 'Mező kitöltése kötelező',
            trigger: 'change'
          }
        ],
        target_user_id: [
          {
            required: true,
            message: 'Mező kitöltése kötelező',
            trigger: 'change'
          }
        ],
        source_storage_id: [
          {
            required: true,
            message: 'Mező kitöltése kötelező',
            trigger: 'change'
          }
        ],
        target_storage_id: [
          {
            required: true,
            message: 'Mező kitöltése kötelező',
            trigger: 'change'
          }
        ],
      },
    };
  },
  computed: {
    storages() {
      return this.$store.getters['storage/storages'];
    },
    users() {
      return this.$store.getters['user/users'];
    },
    title() {
      if (this.type === 'add') {
        return 'Új képviselői áthelyezés';
      } else if (this.type === 'update') {
        return 'Képviselői áthelyezés módosítása';
      } else {
        return '';
      }
    },
    buttonText() {
      if (this.type === 'add') {
        return 'Hozzáadása';
      } else if (this.type === 'update') {
        return 'Módosítás';
      } else {
        return '';
      }
    },
  },
  async mounted() {
    this.loading = true;
    const requiredFetches = [];
    if (!this.users.length) {
      requiredFetches.push(this.$store.dispatch('user/fetchAll'));
    }
    if (!this.storages.length) {
      requiredFetches.push(this.$store.dispatch('storage/fetchAll'));
    }
    await Promise.all(requiredFetches);
    if (this.representativeReplacementId) {
      this.representativeReplacement = await this.$store.dispatch('representativeReplacement/fetch', this.representativeReplacementId);
    }
    this.loading = false;
  },
  methods: {
    handleClose() {
      this.$confirm('Biztosan elveted a módosításokat?', {
        confirmButtonText: 'Igen',
        type: 'warning',
      })
        .then(() => {
          this.$router.replace('/representative-processes/representative-replacements');
        })
        .catch(() => {
        });
    },
    async store() {
      this.$refs['representativeReplacementForm'].validate(async valid => {
        if (valid) {
          this.buttonLoading = true;
          try {
            if (this.type === 'add') {
              await this.$store.dispatch('representativeReplacement/create', this.representativeReplacement);
            } else {
              await this.$store.dispatch('representativeReplacement/update', this.representativeReplacement);
            }
            this.$store.dispatch('representativeReplacement/fetchAll');
            this.$router.replace('/representative-processes/representative-replacements');
          } catch (e) {
          }
          this.buttonLoading = false;
        }
      });
    },
  }
};
</script>
